import { h, render } from 'preact'
import { isEmptyObject } from './modules/utilities.js'
import { SG1Logs } from './modules/logs.js'
import fontIcon from '../fonts/icon-orange.woff2'
import fontHelvetica55 from '../fonts/HelvNeue55_W1G.woff2'
import fontHelvetica75 from '../fonts/HelvNeue75_W1G.woff2'

var isShadowDomFontsInstalled = false

export const componentRender = (data, eventsList) => {
    try {
        // Check si l'evenement exist dans la liste
        if (eventsList[data.id] === undefined) throw (`${data.id} n'est pas configuré`)

        // Check si les données parents ne sont pas vides
        if ((isEmptyObject(data) || (data.zones[0].data && isEmptyObject(data.zones[0].data))) && eventsList[data.id].noData !== true) throw (`${data.id} données manquantes`)

        // Check si les données enfants spécifiées dans 'check' sont présentes
        if (eventsList[data.id].check !== undefined && eventsList[data.id].check.length > 0) {
            for (const key of eventsList[data.id].check) {
                if (data.zones[0].data[key] !== undefined) {
                    const keyData = data.zones[0].data[key]
                    if (Array.isArray(keyData) && data.zones[0].data[key].length === 0) throw (`${eventsList[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'object' && !Array.isArray(keyData) && isEmptyObject(data.zones[0].data[key])) throw (`${eventsList[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'string' && data.zones[0].data[key] === '') throw (`${eventsList[data.id].elementId}: ${key} vide`)
                } else {
                    throw (`${key} non définie`)
                }
            }
        }

        // Render du composant
        if (data.id === data.zones[0].id) {
            let Component = eventsList[data.id].component
            let extraData = eventsList[data.id].data !== undefined ? eventsList[data.id].data : {}

            // Définition de l'id de la section
            let target = eventsList[data.id].elementId

            if (eventsList[data.id].dynamicPosition === true && data.zones[0].data.position > 1) {
                target = eventsList[data.id].elementId + '_' + data.zones[0].data.position
            }
            let targetNode = document.getElementById(target)

            // Injection les fonts en mode shadowdom
            if (eventsList[data.id].shadowDOM === true && isShadowDomFontsInstalled === false) {
                importFonts()
                isShadowDomFontsInstalled = true
            }

            // Injection du shadowDOM
            if (eventsList[data.id].shadowDOM === true) {
                targetNode = targetNode.attachShadow({ mode: "open" })
                const style = document.createElement('style')
                style.textContent = eventsList[data.id].shadowStyle
                targetNode.appendChild(style)
            }

            if (eventsList[data.id].orchestrator !== undefined) {
                eventsList[data.id].orchestrator(data, targetNode)
            } else {
                // Données d'environnement
                const env = {
                    pageId: window.dataStoreHP.pageId,
                    isLogged: window.dataStoreHP.isLogged,
                    device: window.dataStoreHP.device,
                    segRefZ: window.dataStoreHP.segRefZ,
                }
                // Rendu
                if (targetNode !== null) {          
                    render(<Component {...data.zones[0].data} eventId={data.id} {...extraData} {...env} />, targetNode)
                } else {
                    throw (`La section #${targetNode} n'existe pas dans la page`)
                }
            }
        } else {
            // Avec Signal
            if (eventsList[data.id].state !== undefined) {
                let value = {}
                value[data.zones[0].id] = data.zones[0].data
                eventsList[data.id].state.value = value
            }
        }
    } catch (error) {
        console.error(`Generic orchestrator de ${data.id} : `, error)
        SG1Logs.incLog('Err_CORCH')
    }
}

const importFonts = () => {
    //injection d'une balise <style> avec le css de la font
    const fontStyle = document.createElement('style')
    fontStyle.textContent = `
       @font-face {
          font-family: 'icon-orange';
          src: url(${fontIcon}) format('woff2');
          font-weight: 400;
          font-style: normal;
          font-display: block;
       }
 
       @font-face{
          font-family:"o-HelveticaNeue";
          src:url(${fontHelvetica55}) format("woff2");
          font-weight:normal;
          font-style:normal;
          font-display:swap
        }
       
       @font-face{
          font-family: "o-HelveticaNeue";
          src: url(${fontHelvetica75}) format("woff2");
          font-weight: bold;
          font-style: normal;
          font-display: swap
       }
    `
    document.head.appendChild(fontStyle)
}
